import React, { useCallback, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  acceptStyle,
  baseStyle,
  focusedStyle,
  rejectStyle,
} from "./uploadScoreCardStyles.js";
import { MAX_FILE_SIZE } from "../../../features/score-card/constants/formValidations.js";
import "./uploadFileScoreCards.css";
import { UploadFile } from "../../../assets/index.js";

const UploadFileScoreCards = ({ field, form, accept, disabled }) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const clearError = () => setErrorMessage(null);

  const onDropRejected = (files) => {
    try {
      if (files) {
        const error = files[0].errors[0];
        setErrorMessage(error.code);
      }
    } catch (error) {
      console.error("something went wrong with file uploading/selecting");
    }
  };

  const onError = (error) => {};
  const onDrop = useCallback(
    (acceptedFiles) => {
      const acceptedFile = acceptedFiles[0];
      form.setFieldValue(field.name, acceptedFile);
    },
    [form]
  );

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({
      onDrop,
      multiple: false,
      accept,
      maxSize: MAX_FILE_SIZE,
      onError,
      onDropRejected: onDropRejected,
      onDropAccepted: clearError,
      disabled,
    });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  return (
    <div className="upload-score-card-uploader-container">
      <div className="upload-score-card-button-box ">
        <div className="upload-score-card-label">Choose file to upload</div>
        {disabled ? (
          <div className="upload-score-card-choose-button-disabled">
            Browse Files
          </div>
        ) : (
          <div className="upload-score-card-choose-button" {...getRootProps()}>
            Browse Files
          </div>
        )}
      </div>
      <div {...getRootProps({ style, className: disabled ? "disabled" : "" })}>
        <input {...getInputProps()} />

        <div className="d-flex flex-column ">
          <UploadFile />
          <p className="drag-label">
            {field.value ? (
              <span>{field.value.name}</span>
            ) : (
              "Drag and drop files here"
            )}
          </p>
        </div>
      </div>
      <span className="red">{errorMessage}</span>
    </div>
  );
};

export default UploadFileScoreCards;



// WEBPACK FOOTER //
// ./src/components/formik/uploadScoreCard/UploadFileScoreCards.jsx